import { StylesConfig } from 'react-select'
import theme from 'theme'

export const customSelectStyles: StylesConfig<any, any> = {
  option: (base) => ({
    ...base,
    color: theme.colors.text,
  }),
  indicatorSeparator: () => ({
    border: 0,
  }),
  control: (base) => ({
    ...base,
    minHeight: 'none',
    border: 0,
    backgroundColor: 'transparent',
    borderRadius: 0,
    boxShadow: 'none',
    cursor: 'pointer',
  }),
  menuPortal: (base) => ({
    ...base,
    borderColor: 'red',
  }),
  menuList: (base) => ({
    ...base,
    fontFamily: theme.fonts.body,
    fontSize: theme.fontSizes[2],
  }),
  valueContainer: (base) => ({
    ...base,
    fontFamily: theme.fonts.body,
    fontSize: theme.fontSizes[2],
  }),
}
